import {
  ADD_PDF_REPORT_FAILED,
  ADD_PDF_REPORT_REQUEST,
  ADD_PDF_REPORT_SUCCEED,
  GET_PDF_PAYLOAD_BY_ID_FAILED,
  GET_PDF_PAYLOAD_BY_ID_REQUEST,
  GET_PDF_PAYLOAD_BY_ID_SUCCEED,
  GET_PDF_REPORT_BY_NAME_FAILED,
  GET_PDF_REPORT_BY_NAME_REQUEST,
  GET_PDF_REPORT_BY_NAME_SUCCEED,
  GET_PDF_REPORT_FAILED,
  GET_PDF_REPORT_REQUEST,
  GET_PDF_REPORT_SUCCEED,
  SEND_PDF_REPORT_EMAIL_FAILED,
  SEND_PDF_REPORT_EMAIL_REQUEST,
  SEND_PDF_REPORT_EMAIL_SUCCEED,
} from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  elevatorReports: [],
  escalatorReports: [],
  pdfPayload: null,
  pdfLoading: false,
  addPdfLoading: false,
  elevatorsReportsPage: 1,
  elevatorsReportsTotalPages: 1,
  escalatorsReportsPage: 1,
  escalatorsReportsTotalPages: 1,
  emailSending: false,
  emailSent: false,
};

const onGetReports = (state, action) => {
  const {page, totalPages, payload, templateType} = action;
  const object = {pdfLoading: false};
  if (templateType === 'ELEVATOR') {
    object.elevatorReports = payload;
    object.elevatorsReportsPage = page;
    object.elevatorsReportsTotalPages = totalPages;
  } else {
    object.escalatorReports = payload;
    object.escalatorsReportsPage = page;
    object.escalatorsReportsTotalPages = totalPages;
  }
  return updateObject(state, object);
};

const pdfReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PDF_REPORT_REQUEST:
      return updateObject(state, {addPdfLoading: true});
    

    case GET_PDF_PAYLOAD_BY_ID_REQUEST:
      return updateObject(state, {pdfLoading: true, pdfPayload: null});
    case GET_PDF_PAYLOAD_BY_ID_SUCCEED:
      return updateObject(state, {pdfLoading: false, pdfPayload: action.payload});
    case GET_PDF_PAYLOAD_BY_ID_FAILED:
      return updateObject(state, {pdfLoading: false, pdfPayload: null});

    case GET_PDF_REPORT_REQUEST:
      return updateObject(state, {pdfLoading: true});
    case GET_PDF_REPORT_BY_NAME_REQUEST:
      return updateObject(state, {pdfLoading: true});
    case ADD_PDF_REPORT_SUCCEED:
      return updateObject(state, {addPdfLoading: false});
    case GET_PDF_REPORT_SUCCEED:
      return onGetReports(state, action);
    case GET_PDF_REPORT_BY_NAME_SUCCEED:
      return onGetReports(state, action);
    case ADD_PDF_REPORT_FAILED:
      return updateObject(state, {addPdfLoading: false});
    case GET_PDF_REPORT_FAILED:
      return updateObject(state, {pdfLoading: false});
    case GET_PDF_REPORT_BY_NAME_FAILED:
      return updateObject(state, {pdfLoading: false});

    case SEND_PDF_REPORT_EMAIL_REQUEST:
      return updateObject(state, { emailSending: true, emailSent: false });

    case SEND_PDF_REPORT_EMAIL_SUCCEED:
      return updateObject(state, { emailSending: false, emailSent: true });

    case SEND_PDF_REPORT_EMAIL_FAILED:
      return updateObject(state, { emailSending: false, emailSent: false });
    default:
      return state;
  }
};

export default pdfReportsReducer;
